






























import { CourseDetails } from '@/jbi-shared/dto/jtms.dtos';
import { CourseModuleComponentItem } from '@/store/modules/jtms/course-module/course-module.types';
import { CoursePackageComponent } from '@/store/modules/jtms/course-package/course-package.types';
import { RootState } from '@/store/store';
import TableSectionTitle from '@/views/AdminViewGroup/components/TableSectionTitle.vue';
import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component({
  components: {
    TableSectionTitle
  }
})
export default class PricingPackagesTable extends Vue {
  @State((state: RootState) => state.course.courseDetails)
  courseDetails!: CourseDetails;

  @State((state: RootState) => state.course.courseCreationState.hasModules)
  hasModules!: boolean;

  @State(
    (state: RootState) =>
      state.coursePackage.coursePackageTabState.activeCoursePackages
  )
  activeCoursePackages!: CoursePackageComponent[];

  @State(
    (state: RootState) =>
      state.courseModule.courseModulesTabState.activeCourseModules
  )
  activeCourseModules!: CourseModuleComponentItem[];

  hasAssignedCourseModule(coursePackage: CoursePackageComponent): boolean {
    return coursePackage.courseModules.length > 0;
  }

  hasNullCurrencyOrAmount(coursePackage: CoursePackageComponent): boolean {
    return coursePackage.amount === 0 || !coursePackage.currency;
  }

  renderCoursePackages(coursePackage: CoursePackageComponent): string {
    // Convert course modules to map for faster lookups
    const courseModulesFromStateMap: Map<
      number,
      CourseModuleComponentItem
    > = new Map(this.activeCourseModules.map((cm) => [cm.id!, cm]));

    const stringOfCourseModules: string = coursePackage.courseModules
      .map((courseModulesAssignedInPackages) => {
        const matchingCourseModuleFromState = courseModulesFromStateMap.get(
          courseModulesAssignedInPackages.id!
        );

        if (matchingCourseModuleFromState) {
          return matchingCourseModuleFromState.label;
        }
      })
      .join(', ');

    return stringOfCourseModules;
  }

  renderPrice(coursePackage: CoursePackageComponent): string {
    const currency: string = coursePackage.currency;
    const amount: number = coursePackage.amount;

    return `${currency} $${amount}`;
  }
}
